import { Form, Popup, SafeArea } from 'antd-mobile'
import { observer } from 'mobx-react'
import React, { useEffect } from 'react'

import NewEditForm from '@/components/NewEditForm'
import HPopup from '@/components/NewEditForm/UILibrary/HYBVant/HPopup'

import './index.less'

interface SheetFormProps {
  onOk: (params: any) => void
  onCancel: (params: any) => void
  title: string
  json: any
  visible: boolean
  okText?: string
  initialValues?: any
  readed?: boolean
}

const SheetForm: React.FC<SheetFormProps> = (props) => {
  const {
    onOk,
    title = '',
    okText = '确定',
    json,
    visible,
    onCancel,
    initialValues = {},
    readed = false
  } = props

  const [formIt] = Form.useForm()

  const confirm = async () => {
    const fieldValues = await formIt.validateFields()
    onOk(fieldValues)
  }

  useEffect(() => {
    formIt.setFieldsValue({ ...(initialValues || {}) })
  }, [initialValues])

  return (
    <HPopup
      visible={visible}
      onCancel={() => onCancel(false)}
      onOk={confirm}
      title={title}
      onMaskClick={() => onCancel(false)}
      className='sheet-popup'
    >
      <div className='sheet-form'>
        <div className='sheet-form-edit'>
          <NewEditForm
            formInst={formIt}
            formInfo={json?.formInfo}
            layout='horizontal'
            formButtons={[]}
            readed={readed}
          />
        </div>
        <SafeArea position='bottom' />
      </div>
    </HPopup>
  )
}

export default observer(SheetForm)
